import Cookies from 'js-cookie';

export default function getUPrefShipTo() {
  return JSON.parse(Cookies.get('uPref') ?? null)?.shipTo || '';
}
